import createSagaMiddleware__default from '@redux-saga/core';
export * from '@redux-saga/core';



export default createSagaMiddleware__default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js
// module id = 1365
// module chunks = 0